import { getText } from '@educaplay/app-core/language';
import { SVG_minus, SVG_more } from "../elements/SVG";

export const InputUpDown = ({ field, value, handleSave, min, max, icon = false }) => {
  const handleOnChange = ({ target }) => {
    let localValue = parseInt(target.value);
    if (isNaN(localValue)) {
      localValue = 0;
    }
    if (min !== undefined && localValue < min) {
      localValue = min;
    }
    if (max !== undefined && localValue > max) {
      localValue = max;
    }
    if (localValue != value) {
      handleSave(localValue);
    }
  };

  const increase = () => {
    const sent = {
      target: {
        value: value + 1,
      },
    };
    handleOnChange(sent);
  };

  const decrease = () => {
    const sent = {
      target: {
        value: value - 1,
      },
    };
    handleOnChange(sent);
  };

  const handleStartEdit = ({ target }) => {
    target.select();
  };

  return (
    <>
      {" "}
      <div className="flex flex-column">
        {field !== undefined && (
          <label className="e__count__hd" htmlFor={`field_${field}`}>
            {getText("field_" + field + "_title")}
          </label>
        )}
      </div>
      <div className="e-form e-form--number">
        <button onClick={decrease} className="e-btn e-btn--secondary">
          <span className="e-icon"><SVG_minus /></span>
        </button>
        <div className="e-form__input">
          <input
            id={field !== undefined ? `field_${field}` : ""}
            name="Lite license number"
            type="number"
            value={value}
            onChange={handleOnChange}
            onFocus={handleStartEdit}
          />
          {icon && <span className="e-icon">{icon}</span>}
        </div>
        <button onClick={increase} className="e-btn e-btn--secondary">
          <span className="e-icon"><SVG_more /></span>
        </button>
      </div>
    </>
  );
};
